module.exports = __webpack_public_path__ + "static/img/lct.1cebbca.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/lct.png
// module id = DxmA
// module chunks = 1